"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Transforms a latitude with a z value of a tile coordinate to its corresponding y value of a tile coordinate.
 */
function lat2y(lat, z) {
    return (Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) /
        2 * Math.pow(2, z)));
}
exports.lat2y = lat2y;
//# sourceMappingURL=lat2y.js.map